import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaExclamationTriangle,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import GeneralResultsWrapper from './GeneralResults';
import MortalityMorbityWrapper from './MortalityMobidity';
import AttentionWrapper from './Attention';



const Results = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [
        {
            title: 'Resultados Gerais',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/general-results`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Mortalidade e Morbidade',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/mortality-morbidity`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Atenção',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/attention`,
            icon: <FaExclamationTriangle style={{ marginRight: '5px' }} />
        }
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/general-results`]:
            'Resultados Gerais dos Indicadores',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/mortality-morbidity`]:
            'Resultados dos Indicadores de Mortalidade e Morbidade',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/attention`]: 'Resultados dos Indicadores de Atenção'
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="general-results" replace />}
                        />
                        <Route
                            path="mortality-morbidity"
                            element={<MortalityMorbityWrapper />}
                        />
                        <Route
                            path="general-results"
                            element={<GeneralResultsWrapper />}
                        />
                        <Route
                            path="attention"
                            element={<AttentionWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Results;
